import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerDirective } from 'ngx-color-picker';
import { ValueAccessorBase } from '../default-class/value-accessor';

@Component({
    selector: 'tidy-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ColorPickerDirective, ReactiveFormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ColorPickerComponent,
            multi: true,
        },
    ],
    standalone: true
})
export class ColorPickerComponent extends ValueAccessorBase<string> implements OnInit {
  
  @Input() form: FormControl = new FormControl();
  @Input() submitted: boolean;
  @Input() errorMessage: string;

  constructor() {
    super();
  }

  ngOnInit() {
    // Set initial value from form control if it exists
    if (this.form && this.form.value) {
      this.value = this.form.value;
    }

    // Subscribe to form control changes
    this.form.valueChanges.subscribe(newValue => {
      if (newValue !== this.value) {
        this.value = newValue;
      }
    });
  }

  onColorChange(color: string) {
    this.value = color;
    if (this.form) {
      this.form.patchValue(color, { emitEvent: false });
    }
  }
} 